import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axios, { AxiosRequestConfig } from 'axios';
import { MoonPayBuySellQuoteParams } from '../../../types/types';

const moonPayIpKey = import.meta.env.VITE_MOONPAY_CLIENT_API;

const getIpAddresses = async (): Promise<[any, any]> => {

    const url = "https://api.moonpay.com";

    try {

        const axiosConfig: AxiosRequestConfig = {
            method: "get",
            url: `${url}/v4/ip_address`,
            params: {
                apiKey: moonPayIpKey
            }
        };

        const response = await axios.request(axiosConfig);

        return [null, response.data]

    } catch (axiosError: any) {


        return [axiosError.response.data, null]
    }

}

const getCurrencyBuyQuote = async (params:MoonPayBuySellQuoteParams) => {

    const url = "https://api.moonpay.com";

    try {

        const axiosConfig: AxiosRequestConfig = {
            method: "get",
            url: `${url}/v3/currencies/${params.quoteCurrencyCode}/buy_quote`,
            params: {
                apiKey: moonPayIpKey,
                baseCurrencyAmount: params.baseCurrencyAmount,
                baseCurrencyCode: params.baseCurrencyCode,
                quoteCurrencyAmount:params.quoteCurrencyAmount,
                fixed:params.fixed,
                areFeesIncluded:params.areFeesIncluded,
                regionalPricing:params.regionalPricing
            }
        };

        const response = await axios.request(axiosConfig);

        return [null, response.data]

    } catch (axiosError: any) {


        return [axiosError.response.data, null]
    }

}

const getCurrencySellQuote = async (params:MoonPayBuySellQuoteParams)=>{

    const url = "https://api.moonpay.com";

    try {

        const axiosConfig: AxiosRequestConfig = {
            method: "get",
            url: `${url}/v3/currencies/${params.baseCurrencyCode}/sell_quote`,
            params: {
                apiKey: moonPayIpKey,
                baseCurrencyAmount: params.baseCurrencyAmount,
                baseCurrencyCode: params.baseCurrencyCode,
                fixed:params.fixed,
                areFeesIncluded:params.areFeesIncluded,
                regionalPricing:params.regionalPricing,
                quoteCurrencyCode:params.quoteCurrencyCode
            }
        };

        const response = await axios.request(axiosConfig);

        return [null, response.data]

    } catch (axiosError: any) {


        return [axiosError.response.data, null]
    }

}

export const moonPayClientApi = createApi({
    reducerPath: "moonpay",
    baseQuery: fetchBaseQuery({ baseUrl: '/ ' }),
    endpoints: (builder) => ({
        getIp: builder.query({
            async queryFn() {

                const [error, response] = await getIpAddresses();

                if (error) {
                    return { error: error, data: undefined }
                }

                return { error: undefined, data: response }
            },
        }),
        getBuyQuote: builder.query<any, MoonPayBuySellQuoteParams>({
            async queryFn(params: MoonPayBuySellQuoteParams) {

                const [error, response] = await getCurrencyBuyQuote(params);

                if (error) {
                    return { error: error, data: undefined }
                }

                return { error: undefined, data: response }
            },
        }),
        getSellQuote: builder.query<any, MoonPayBuySellQuoteParams>({
            async queryFn(params: MoonPayBuySellQuoteParams) {

                const [error, response] = await getCurrencySellQuote(params);

                if (error) {
                    return { error: error, data: undefined }
                }

                return { error: undefined, data: response }
            },
        }),
    })
})

export const {
    useGetIpQuery,
    useGetBuyQuoteQuery,
    useGetSellQuoteQuery
} = moonPayClientApi 